import React, { createContext, useState, useEffect } from "react";
import PocketBase from "pocketbase";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);
export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({ isAuthenticated: pb.authStore.isValid, token: pb.authStore.token });

  useEffect(() => {
    const unsubscribe = pb.authStore.onChange(() => {
      setAuth({ isAuthenticated: pb.authStore.isValid, token: pb.authStore.token });
    });

    return () => unsubscribe();
  }, []);

  return <AuthContext.Provider value={{ auth, setAuth }}>{children}</AuthContext.Provider>;
};

export { AuthProvider };
